import { render, staticRenderFns } from "./modal2fa.vue?vue&type=template&id=279e2b1a&scoped=true&"
import script from "./modal2fa.vue?vue&type=script&lang=js&"
export * from "./modal2fa.vue?vue&type=script&lang=js&"
import style0 from "./modal2fa.vue?vue&type=style&index=0&id=279e2b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e2b1a",
  null
  
)

export default component.exports